import AcordaoApi from './AcordaoApi';
import AdvogadoSustentacaoOralApi from './AdvogadoSustentacaoOralApi';
import AnotacaoApi from './AnotacaoApi';
import AssinaturaApi from './AssinaturaApi';
import CertidaoApi from './CertidaoApi';
import ClienteEnvelopeApi from './ClienteEnvelopeApi';
import HealthCheckApi from './HealthCheckApi';
import LoginApi from './LoginApi';
import FotoMagistradoApi from './FotoMagistradoApi';
import MovimentoCNJApi from './MovimentoCNJApi';
import PautaApi from './PautaApi';
import PecasApi from './PecasApi';
import ProcessoApi from './ProcessoApi';
import SecretariaApi from './SecretariaApi';
import SessaoApi from './SessaoApi';
import TipoJulgamentoApi from './TipoJulgamentoApi';
import VersaoOrigemApi from './VersaoOrigemApi';
import ValidacaoPreSessaoApi from './ValidacaoPreSessaoApi';
import CalendarioApi from './CalendarioApi';

export default class ApiFactory {
    static _instance;

    _usuario;

    _advogadoSustentacaoOralApi;
    _loginApi;
    _processoApi;
    _sessaoApi;
    _pecasApi;
    _certidaosApi;
    _acordaoApi;
    _movimentoCNJApi;
    _anotacaoApi;
    _assinaturaApi;
    _secretariaApi;
    _healthCheckApi;
    _versaoOrigemApi;
    _clienteEnvelopeApi;
    _fotoMagistradoApi;
    _tipoJulgamentoApi;
    _calendarioApi;

    constructor(usuario) {
        this._usuario = usuario;
    }

    static getInstance() {
        if (!ApiFactory._instance) {
            ApiFactory._instance = new ApiFactory();
        }
        return ApiFactory._instance;
    }

    static reset(usuario) {
        ApiFactory._instance = new ApiFactory(usuario);
    }

    getAdvogadoSustentacaoOralApi() {
        if (!this._advogadoSustentacaoOralApi) {
            this._advogadoSustentacaoOralApi = new AdvogadoSustentacaoOralApi(this._usuario);
        }
        return this._advogadoSustentacaoOralApi;
    }

    getLoginApi() {
        if (!this._loginApi) {
            this._loginApi = new LoginApi(this._usuario);
        }
        return this._loginApi;
    }

    getProcessoApi() {
        if (!this._processoApi) {
            this._processoApi = new ProcessoApi(this._usuario);
        }
        return this._processoApi;
    }

    getSessaoApi() {
        if (!this._sessaoApi) {
            this._sessaoApi = new SessaoApi(this._usuario);
        }
        return this._sessaoApi;
    }

    getPautaApi() {
        if (!this._pautaApi) {
            this._pautaApi = new PautaApi(this._usuario);
        }
        return this._pautaApi;
    }

    getPecasApi() {
        if (!this._pecasApi) {
            this._pecasApi = new PecasApi(this._usuario);
        }
        return this._pecasApi;
    }

    getAnotacaoApi() {
        if (!this._anotacaoApi) {
            this._anotacaoApi = new AnotacaoApi(this._usuario);
        }
        return this._anotacaoApi;
    }

    getAssinaturaApi() {
        if (!this._assinaturaApi) {
            this._assinaturaApi = new AssinaturaApi(this._usuario);
        }
        return this._assinaturaApi;
    }

    getCertidaoApi() {
        if (!this._certidaoApi) {
            this._certidaoApi = new CertidaoApi(this._usuario);
        }
        return this._certidaoApi;
    }

    getAcordaoApi() {
        if (!this._acordaoApi) {
            this._acordaoApi = new AcordaoApi(this._usuario);
        }
        return this._acordaoApi;
    }

    getMovimentoCNJApi() {
        if (!this._movimentoCNJApi) {
            this._movimentoCNJApi = new MovimentoCNJApi(this._usuario);
        }
        return this._movimentoCNJApi;
    }

    getSecretariaApi() {
        if (!this._secretariaApi) {
            this.secretariaApi = new SecretariaApi(this._usuario);
        }
        return this.secretariaApi;
    }

    getHealthCheckApi() {
        if (!this._healthCheckApi) {
            this._healthCheckApi = new HealthCheckApi(this._usuario);
        }
        return this._healthCheckApi;
    }

    getVersaoOrigemApi() {
        if (!this._versaoOrigemApi) {
            this._versaoOrigemApi = new VersaoOrigemApi(this._usuario);
        }
        return this._versaoOrigemApi;
    }

    getClienteEnvelopeApi() {
        if (!this._clienteEnvelopeApi) {
            this._clienteEnvelopeApi = new ClienteEnvelopeApi(this._usuario);
        }
        return this._clienteEnvelopeApi;
    }

    getFotoMagistradoApi() {
        if (!this._fotoMagistradoApi) {
            this._fotoMagistradoApi = new FotoMagistradoApi(this._usuario);
        }
        return this._fotoMagistradoApi;
    }

    getTipoJulgamentoApi() {
        if (!this._tipoJulgamentoApi) {
            this._tipoJulgamentoApi = new TipoJulgamentoApi(this._usuario);
        }
        return this._tipoJulgamentoApi;
    }
    getValidacaoPreSessaoApi() {
        if (!this._validacaoPreSessaoApi) {
            this._validacaoPreSessaoApi = new ValidacaoPreSessaoApi(this._usuario);
        }
        return this._validacaoPreSessaoApi;
    }
    getCalendarioApi() {
        if (!this._calendarioApi) {
            this._calendarioApi = new CalendarioApi(this._usuario);
        }
        return this._calendarioApi;
    }
}
